import { useRef, useState, useEffect, useCallback } from 'react';
import Packery from 'packery';
import Draggabilly from 'draggabilly';
import { PACKERY_EVENTS } from '../context/PackeryContext';
import useStorage from '../context/StorageContext';
import useEmitterListener from './useEmitterListener';
import consoleLogDev from './loggingHelper';
import { useDebouncedCallback } from 'use-debounce';

Packery.prototype.getShiftPositions = function( attrName ) {
    attrName = attrName || 'id';
    var _this = this;

    return this.items.filter(item => item.element.getAttribute(attrName)).map( function( item ) {
        return {
            attr: item.element.getAttribute( attrName ),
            x: item.rect.x / _this.packer.width,
            "rect-x": item.rect.x,
            "rect-y": item.rect.y
        }
    });
};

export default function usePackery(props) {
    const { options } = props;
    
    const { storeData } = useStorage();

    const packeryEleRef = useRef();
    const packery = useRef(null);

    const [domChildren, setDomChildren] = useState([]);

    const getNewDomChildren = useCallback(() => {
        var node = packeryEleRef.current;
        var children = options.itemSelector ? node.querySelectorAll(options.itemSelector) : node.children;

        return Array.prototype.slice.call(children);
    }, [options.itemSelector]);

    const diffDomChildren = useCallback(() => {
        var oldChildren = domChildren.filter(function(element) {
            return !!element.parentNode;
        });

        var newChildren = getNewDomChildren();

        var removed = oldChildren.filter(function(oldChild) {
            return !~newChildren.indexOf(oldChild);
        });

        // get everything added to the end of the DOMNode list
        var moved = [];

        if (removed.length === 0) {
            moved = oldChildren.filter(function(child, index) {
                return index !== newChildren.indexOf(child);
            });
        }

        return {
            old: oldChildren,
            new: newChildren,
            moved: moved
        };
    }, [domChildren, getNewDomChildren]);

    const storeCurrentPosition = useCallback(() => {
        const positions = packery.current.getShiftPositions('data-item-id');
        //consoleLogDev("positions", positions);

        let positionsToStore = positions.map(
            (item, index) => ({
                DashboardVariantCardRetrievalID: item.attr,
                Ordinal: index + 1
            })
        );

        storeData(positionsToStore);
    }, [storeData]);

    const storeCurrentPositionDebounce = useDebouncedCallback(() => { storeCurrentPosition(); }, 1000);

    const performLayout = useCallback((packeryInstance) => {
        consoleLogDev("Perform Layout");

        var diff = diffDomChildren();

        if (diff.moved.length > 0) {
            packeryInstance.reloadItems();
        }

        setDomChildren(diff.new);

        packeryInstance.layout();

        //handles the weird glitches where animations and layouts don't happen as expected
        setTimeout(function () {
            packeryInstance.layout();
        }, 0);

        storeCurrentPositionDebounce();
    }, [diffDomChildren, storeCurrentPositionDebounce]);

    const refreshLayout = useDebouncedCallback(() => { performLayout(packery.current); }, 100);

    useEffect(() => {
        //packery initialize
        if (!packery.current) {
            setDomChildren(getNewDomChildren());

            var packeryInstance = new Packery(
                packeryEleRef.current,
                props.options
            );

            //bind Draggabilly Events
            packeryInstance.getItemElements()
                .forEach((gridItem) => {
                    const draggableItem = new Draggabilly( gridItem, { handle: 'i.drag-handle' } );
                    packeryInstance.bindDraggabillyEvents( draggableItem );
                });

            // save drag positions on event
            packeryInstance.on('dragItemPositioned', function() {
                performLayout(packeryInstance); 
            });

            //store packery instance
            packery.current = packeryInstance;

            window.packery = packeryInstance;
         } 

    }, [props.options, getNewDomChildren, performLayout]);

    useEmitterListener(props.componentName, PACKERY_EVENTS.ALL_CHILDREN_LOADED, refreshLayout);

    return { packeryEleRef, refreshLayout };
}

/*
function StorageStuff() {
    const createPackeryInstance = useCallback(() => {
        //store packery instance
        var packeryInstance = new Packery(
            packeryEleRef.current,
            props.options
        );

        setPackery(packeryInstance);

        return packeryInstance;
    }, [props.options]);

    const bindPackeryEvents = useCallback((packery) => {
        packery.on('dragItemPositioned', function() {
            // save drag positions
            const positions = packery.getShiftPositions('data-item-id');
            consoleLogDev("positions", positions);
            // localStorage.setItem( 'dragPositions', JSON.stringify( positions ) );
        });
    }, []);

    const bindDraggabillyEvents = useCallback((packery) => {
        packery.getItemElements().forEach(function(gridItem) {
            const draggableItem = new Draggabilly( gridItem );
            packery.bindDraggabillyEvents( draggableItem );
        });
    }, []);

    const initializePackery = useCallback((force) => {
        if (!packery || force) {

            var packeryInstance = createPackeryInstance();

            setDomChildren(getNewDomChildren());

            // get saved dragged positions
            const initPositions = localStorage.getItem('dragPositions');
            consoleLogDev("initPositions", initPositions);

            bindDraggabillyEvents(packeryInstance);

            // init layout with saved positions
            //packeryInstance.initShiftLayout(initPositions, 'data-item-id');

            bindPackeryEvents(packeryInstance);
        }
    }, [bindPackeryEvents, bindDraggabillyEvents, createPackeryInstance, packery, getNewDomChildren]);
}
*/